// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/hooks/useBodyScrollLock.js

import { useEffect } from "react";

let activeLocks = 0;
let restoreSnapshot = null;

export default function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active || typeof document === "undefined") return undefined;

    const body = document.body;
    const documentElement = document.documentElement;

    if (activeLocks === 0) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      restoreSnapshot = {
        bodyOverflow: body.style.overflow,
        bodyPaddingRight: body.style.paddingRight,
        htmlOverflow: documentElement.style.overflow,
      };

      body.style.overflow = "hidden";
      documentElement.style.overflow = "hidden";

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    activeLocks += 1;

    return () => {
      activeLocks = Math.max(0, activeLocks - 1);

      if (activeLocks === 0 && restoreSnapshot) {
        body.style.overflow = restoreSnapshot.bodyOverflow;
        body.style.paddingRight = restoreSnapshot.bodyPaddingRight;
        documentElement.style.overflow = restoreSnapshot.htmlOverflow;
        restoreSnapshot = null;
      }
    };
  }, [active]);
}
